import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import { colorTokens } from '@eruvaka/web-pondlogs-base';
import { useTranslation } from '@eruvaka/web-pondlogs-i18n';
export const NotificationBell = (props) => {
    const { notifications = [], onNotificationClick, onMarkAllAsRead } = props;
    const { t } = useTranslation('main');
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const unreadCount = notifications.filter((n) => !n.isRead).length;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleNotificationClick = (notification) => {
        onNotificationClick?.(notification);
        handleClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { "aria-label": `${unreadCount} unread notifications`, "aria-controls": isOpen ? 'notification-menu' : undefined, "aria-haspopup": "true", "aria-expanded": isOpen ? 'true' : undefined, onClick: handleClick, sx: {
                    color: colorTokens.gray600,
                    '&:hover': {
                        backgroundColor: colorTokens.gray100,
                    },
                }, children: _jsx(Badge, { badgeContent: unreadCount, color: "error", sx: {
                        '& .MuiBadge-badge': {
                            fontSize: 11,
                            height: 18,
                            minWidth: 18,
                            fontWeight: 600,
                        },
                    }, children: _jsx(NotificationsNoneRoundedIcon, { sx: { fontSize: 24 } }) }) }), _jsxs(Menu, { id: "notification-menu", anchorEl: anchorEl, open: isOpen, onClose: handleClose, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, slotProps: {
                    paper: {
                        sx: {
                            mt: 1,
                            width: 360,
                            maxHeight: 480,
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: colorTokens.gray200,
                            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                        },
                    },
                    list: {
                        sx: {
                            p: 0,
                        },
                    },
                }, children: [_jsxs(Box, { sx: {
                            px: 2,
                            py: 1.5,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: `1px solid ${colorTokens.gray200}`,
                        }, children: [_jsx(Typography, { variant: "body1", sx: { fontWeight: 600, fontSize: 14 }, children: t('notifications.title') }), unreadCount > 0 && (_jsx(Typography, { variant: "caption", sx: {
                                    color: colorTokens.secondary,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    '&:hover': {
                                        textDecoration: 'underline',
                                    },
                                }, onClick: () => {
                                    onMarkAllAsRead?.();
                                    handleClose();
                                }, children: t('notifications.markAllRead') }))] }), notifications.length === 0 ? (_jsxs(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            py: 6,
                            px: 2,
                        }, children: [_jsx(NotificationsNoneRoundedIcon, { sx: { fontSize: 48, color: colorTokens.gray300, mb: 1 } }), _jsx(Typography, { variant: "body2", sx: { color: colorTokens.gray600, fontSize: 13 }, children: t('notifications.empty') })] })) : (notifications.map((notification, index) => (_jsxs(Box, { children: [_jsx(MenuItem, { onClick: () => handleNotificationClick(notification), sx: {
                                    px: 2,
                                    py: 1.5,
                                    backgroundColor: notification.isRead ? 'transparent' : colorTokens.secondaryLight,
                                    '&:hover': {
                                        backgroundColor: notification.isRead
                                            ? colorTokens.gray50
                                            : colorTokens.secondaryLight,
                                    },
                                    minHeight: 'auto',
                                    alignItems: 'flex-start',
                                }, children: _jsxs(Box, { sx: { width: '100%' }, children: [_jsxs(Box, { sx: {
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                mb: 0.5,
                                            }, children: [_jsx(Typography, { variant: "body2", sx: {
                                                        fontWeight: notification.isRead ? 400 : 600,
                                                        fontSize: 13,
                                                        color: colorTokens.gray800,
                                                        flex: 1,
                                                    }, children: notification.title }), !notification.isRead && (_jsx(Box, { sx: {
                                                        width: 8,
                                                        height: 8,
                                                        borderRadius: '50%',
                                                        backgroundColor: colorTokens.secondary,
                                                        ml: 1,
                                                        mt: 0.5,
                                                    } }))] }), _jsx(Typography, { variant: "caption", sx: {
                                                color: colorTokens.gray600,
                                                fontSize: 12,
                                                display: 'block',
                                                mb: 0.5,
                                            }, children: notification.message }), _jsx(Typography, { variant: "caption", sx: {
                                                color: colorTokens.gray500,
                                                fontSize: 11,
                                            }, children: notification.timestamp })] }) }), index < notifications.length - 1 && _jsx(Divider, {})] }, notification.id))))] })] }));
};
